import type { ApiResponse } from "@entrilia/shared/api/types";
import type { CancellationToken, RunTileReportRequest, TileDataResponse } from "../../../../../../api/types/svTypes.ts";
import type { TileRunState } from "../../../../reporting/sv/components/viewer/storage/runState.ts";
import useRequestConfigViewer from "../../../../reporting/sv/components/viewer/tile/hooks/useRequestConfigViewer.ts";
import useTileDataViewer from "../../../../reporting/sv/components/viewer/tile/hooks/useTileDataViewer.tsx";
import PreviewComponent from "../../../../reporting/sv/components/viewer/tile/PreviewComponent.tsx";
import SmartViewWidgetViewerWrapper from "../SmartViewWidgetViewerWrapper";

interface Props {
  runState: TileRunState;
  runReport: (
    dataSetId: string,
    body: RunTileReportRequest,
    done: (data: ApiResponse<TileDataResponse>) => void,
    error: (reason: string | undefined) => void
  ) => CancellationToken;
}

const SmartViewTileWidgetViewer = ({ runState, runReport }: Props) => {
  const { requestConfig: viewConfig } = useRequestConfigViewer({
    sessionId: "",
    isQueryLoggingActive: false,
  });

  const data = useTileDataViewer({
    requestConfig: viewConfig,
    runReport,
    updateDevTools: undefined,
    setEtag: undefined,
    fields: runState.fields,
  });

  return (
    <SmartViewWidgetViewerWrapper
      initialized={data.initialized}
      validity={data.configurationValidity}
      sx={{ overflow: "auto" }}
    >
      <PreviewComponent data={data} fields={runState.fields} />
    </SmartViewWidgetViewerWrapper>
  );
};

export default SmartViewTileWidgetViewer;
